import { countryPhoneNumbers, formatPhoneNumber } from "./validation";

// Format OTP code
export const formatOTP = (OTP) => {
  let code = OTP.replace(/[\D\s-]/g, "");
  if (code.length === 6) {
    code = code.slice(0, 2) + " " + code.slice(2, 4) + " " + code.slice(4, 6);
  } else {
    code = OTP;
  }
  return code;
};

/**
 * Format Money To a currency format
 */
export const formatMoney = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "XOF",
  useGrouping: true,
  notation: "standard",
  currencyDisplay: "symbol",
});

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export const formatDate = (date: Date | number | string) => {
  if (!date) return "Date invalide";

  // Convertir string numérique en nombre
  const parsed =
    typeof date === "string" && /^\d+$/.test(date) ? parseInt(date) : date;

  // Si c'est un timestamp en secondes, convertir en millisecondes
  const timestamp =
    typeof parsed === "number" && parsed < 1e12 ? parsed * 1000 : parsed;

  const dateToFormat = new Date(timestamp);

  if (isNaN(dateToFormat.getTime())) return "Date invalide";

  const opt: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const weekdayOpt: Intl.DateTimeFormatOptions = { weekday: "long" };

  const weekday = toTitleCase(
    dateToFormat.toLocaleDateString("fr-FR", weekdayOpt)
  );

  const time = `${dateToFormat.getHours()} h ${dateToFormat
    .getMinutes()
    .toString()
    .padStart(2, "0")} mn`;

  return `${weekday}, ${dateToFormat.toLocaleDateString(
    "fr-FR",
    opt
  )} à ${time}`;
};

/**
 * Format phone number according to country format
 * @param isoCountryCode - Country ISO code (default: "SN")
 * @param phone - Phone number to format
 * @returns Formatted phone number (e.g., "77 556 58 80")
 */
export const formatPhone = (isoCountryCode = "SN", phone: string): string => {
  // Use the new formatPhoneNumber function from validation.ts
  return formatPhoneNumber(isoCountryCode, phone);
};

/**
 * @param text
 * @returns textwithoutspace
 */
export const removeSpace = (text: string) => text.replace(/[\D\s-]/g, "");
